module.exports = __webpack_public_path__ + "static/assets/3dca3b69db5604cf1a0c48b7e4942fd7.svg";